import {
  COMPONENT_VALUE_TYPES as types,
  PERCENTAGES,
  BACKGROUND_IMAGE_POSITION
} from 'shared/constants';

const propsSchema = [
  {
    key: 'bg_img',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'dark_overlay',
        label: 'Dark Overlay',
        type: types.ENUM,
        options: PERCENTAGES
      },
      {
        key: 'position',
        label: 'Background Position',
        type: types.ENUM,
        options: BACKGROUND_IMAGE_POSITION
      }
    ]
  },
  {
    key: 'headline',
    label: 'Headline',
    type: types.TEXT
  },
  {
    key: 'titles',
    label: 'Titles per each line',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  bg_img: {
    url: 'https://genesis-cdn.ff.com/our_company/00_marquee/our-company-virtual-reality-modeling-design.jpg',
    dark_overlay: '0',
    position: 'LEFT CENTER'
  },
  headline: 'We are a user-centric, advanced mobility company with headquarters in Silicon Valley and Southern California. Our team leverages the talents of passionate creators from the technology and automotive industries to bring premium, seamlessly connected electric vehicles.',
  titles: [
    {
      title: 'Hello.'
    },
    {
      title: 'We are Faraday Future'
    },
    {
      title: 'from California.'
    }
  ]
};

export default {
  title: 'Copy Landing',
  id: 'CopyLanding',
  propsSchema,
  defaultProps
};
